import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * from './actions';
export * as bonusesSelectors from './selectors';

export default reducer;
